import React, { useState } from "react";
import cn from "classnames";

import Modal from "../../../../components/Modal";
import Score from "../../../../components/Score/score-display";
import { PagingAction, PageNumber } from "../../../../components/Paging";
import Icon from "../../../../icon";

import { Wrapper, Pagination } from "./styles";
import { IProps } from "./interfaces";

const Scores = ({ plan, close }: IProps) => {
    const [current, setCurrent] = useState(0);
    const goTo = (newCurrent: number) => {
        setCurrent(newCurrent)
    };
    const score = plan.scores[current];
    const wrapperScale = (window.innerWidth * 0.7) / 1280;
    return (
        <Modal close={close} width="70vw" height="80vh">
            <Pagination>
                <PagingAction
                    className={cn("button", "button--light")}
                    onClick={() => goTo(current - 1)}
                    disabled={current === 0}
                >
                    <Icon i="arrowback" />
                </PagingAction>
                <PageNumber>{current + 1}</PageNumber>
                <PagingAction
                    className={cn("button", "button--light", "Flip")}
                    onClick={() => goTo(current + 1)}
                    disabled={current >= plan.scores.length - 1}
                >
                    <Icon i="arrowback" />
                </PagingAction>
            </Pagination>
            <Wrapper
                style={{
                    width: 1280,
                    transform: `scale(${wrapperScale})`,
                    height: `calc(${80 / wrapperScale}vh - ${50 / wrapperScale}px)`,
                }}
            >
                <Score score={score.score} scale={score.scale} />
            </Wrapper>
        </Modal>
    );
}

export default Scores;
